import axios from '@/axios'
import { getMessageFromError } from '../utils/functions'

export default {
  async fetchAllPermissions({ commit }) {
    // try {
    //   const res = await this.$http.get('/admin/access-permission/all-permissions')
    //   if (res.data.success) {
    //     commit('SET_ALL_PERMISSIONS', res.data.data)
    //   }
    // } catch (error) {
    //   console.error('Failed to fetch permissions:', error)
    // }
  },
  async fetchAllRoles({ commit }) {
    // try {
    //   const res = await this.$http.get('/admin/role/all-roles')
    //   if (res.data.success) {
    //     commit('SET_ROLE', res.data.data)
    //   }
    // } catch (error) {
    //   console.error('Failed to fetch roles:', error)
    // }
  },

  // login action
  async login({ commit, root }, data) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await this.$http.post('/admin/auth/login', data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      // const loginResponse = res.data.data
      return {
        success: res.data.success,
        message: res.data.message
      }

      // commit('SET_STATE', {
      //   action: 'userInfo',
      //   data: loginResponse.user
      // })
      // axios.defaults.headers.common['Authorization'] = `Bearer ${loginResponse.tokens.access.token}`
      // localStorage.setItem('accessToken', loginResponse.tokens.access.token)
      // localStorage.setItem('refreshToken', loginResponse.tokens.refresh.token)
      // localStorage.setItem('userName', `${loginResponse.user.first_name} ${loginResponse.user.last_name}`)
      // localStorage.setItem('email', loginResponse.user.email)
      // commit('SET_BEARER', loginResponse.tokens.access.token)
      // commit('SET_PERMISSIONS', res.data.access_permissions)
      // commit('SET_USER_INFO', loginResponse.user)
      // commit('SET_STATE', {
      //   action: 'user',
      //   data: loginResponse.user
      // })

      // return {
      //   data: loginResponse,
      //   message: res.data.message
      // }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const messages = getMessageFromError(error)
      return Promise.reject(messages)
    }
  },

  // resend otp
  async resendOtp({ commit, root }, data) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await this.$http.post('/admin/auth/resend-otp', data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        success: res.data.success,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const messages = getMessageFromError(error)
      return Promise.reject(messages)
    }
  },

  // Verify Otp
  async verifyOtp({ commit }, data) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await this.$http.post('/admin/auth/verify-otp', data)
      const loginResponse = res.data.data

      commit('SET_STATE', {
        action: 'userInfo',
        data: loginResponse.user
      })
      axios.defaults.headers.common['Authorization'] = `Bearer ${loginResponse.tokens.access.token}`
      localStorage.setItem('accessToken', loginResponse.tokens.access.token)
      localStorage.setItem('refreshToken', loginResponse.tokens.refresh.token)
      localStorage.setItem('userName', `${loginResponse.user.first_name} ${loginResponse.user.last_name}`)
      localStorage.setItem('image', loginResponse.user.image)
      localStorage.setItem('email', loginResponse.user.email)
      if (loginResponse.gurudwara && loginResponse.gurudwara.square_thumbnail) {
        localStorage.setItem('gurudwaraImage', loginResponse.gurudwara.square_thumbnail)
      }
      if (loginResponse.hotel) {
        localStorage.setItem('hotel', JSON.stringify(loginResponse.hotel))
      }
      localStorage.setItem('roleSlug', (loginResponse.user.role && loginResponse.user.role.slug) || '')
      commit('SET_BEARER', loginResponse.tokens.access.token)
      commit('SET_PERMISSIONS', res.data.access_permissions)
      commit('SET_USER_INFO', loginResponse.user)
      commit('SET_STATE', {
        action: 'user',
        data: loginResponse.user
      })

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      return {
        data: loginResponse,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const messages = getMessageFromError(error)
      return Promise.reject(messages)
    }
  },

  // change password action.
  async changePassword({ commit }, data) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await this.$http.put('admin/auth/change-password', data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const messages = getMessageFromError(error)
      return Promise.reject(messages)
    }
  },

  // logout action
  async logoutUser({ commit }, data) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await this.$http.post('user/logout', data)
      localStorage.removeItem('accessToken')
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        message: res.data.msg
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const messages = getMessageFromError(error)
      return Promise.reject(messages)
    }
  },

  // update profile action.
  async updateProfile({ commit }, data) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await this.$http.put('/user/update-user', data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  },

  // get admin profile action.
  async getUserProfile({ commit }) {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await this.$http.get('/auth/verify-token')

      commit('SET_PERMISSIONS', res.data.access_permissions)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      commit('SET_STATE', {
        action: 'userInfo',
        data: res.data.data.user
      })

      commit('SET_USER_ROLE', res.data.data.user.role.role_name)
      return {
        data: res.data.data.user,
        message: res.data.message
      }
    } catch (error) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(error)
      return Promise.reject({
        message
      })
    }
  }
}
